import React, {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import {css} from "@emotion/react";

import {centerText, w100} from "@pg-design/helpers-css";
import {usePrevious} from "@pg-mono/hooks";
import {RequestState} from "@pg-mono/request-state";

import {IRPStore} from "../../app/rp_reducer";
import {IOSMPoisRoutesGrouped} from "../../maps/actions/fetch_osm_pois_routes_grouped";
import {IRegionListMap} from "../../region/types/IRegionListMap";
import {ViewType} from "../../view_type/ViewType";
import {useGetMapRegionsQuery} from "../map/api/get_map_region";
import {IOfferListMapOffer} from "../types/IOfferListMapOffer";
import {OSMapForOffers} from "./os_map_for_offers/OSMapForOffers";

const mapBg = require("../map/img/map_bg.jpg");

interface IProps {
    transportRoutes: IOSMPoisRoutesGrouped[] | null;
    className?: string;
    onMarkerClick: (offerId: number) => void;
    offers: IOfferListMapOffer[];
    offersRequestState: RequestState;
    isHoliday: boolean;
    hideLayersBox?: boolean;
}

export const OfferListMap = (props: IProps) => {
    const {offers} = props;

    const selectedRegion = useSelector((state: IRPStore) => state.offerListMap.selectedRegion);
    const favouriteOffers = useSelector((state: IRPStore) => state.favourite.favourites.offers);
    const appliedOffers = useSelector((state: IRPStore) => state.offerListMap.appliedOffers.data);

    const [stateOffers, setStateOffers] = useState<IOfferListMapOffer[]>(offers);
    const {data: regionData, isSuccess: isRegionRequestSucceeded} = useGetMapRegionsQuery({region: selectedRegion.map((region) => region.id)});
    const [stateRegionData, setStateRegionData] = useState<IRegionListMap[]>(regionData?.results || []);

    const prevOffersRequestState = usePrevious(props.offersRequestState, props.offersRequestState);
    const prevRegionRequestState = usePrevious(isRegionRequestSucceeded, isRegionRequestSucceeded);

    useEffect(() => {
        const offersChanged = prevOffersRequestState !== props.offersRequestState;
        const offersSuccess = props.offersRequestState === RequestState.Success;
        const regionChanged = prevRegionRequestState !== isRegionRequestSucceeded;

        if (props.isHoliday) {
            if (offersSuccess && offersChanged) {
                setStateOffers(props.offers);
                setStateRegionData(regionData?.results || []);
            }
        } else {
            if (offersSuccess && isRegionRequestSucceeded && (offersChanged || regionChanged)) {
                setStateOffers(props.offers);
                setStateRegionData(regionData?.results || []);
            }
        }
    }, [props.isHoliday, props.offersRequestState, isRegionRequestSucceeded, props.offers, regionData, prevOffersRequestState, prevRegionRequestState]);

    const markersLength = props.offers.length;
    const isError = props.offersRequestState === RequestState.Error;

    return (
        <>
            {(!markersLength || isError) && (
                <div css={emptyListMap}>
                    <section css={centerText}>
                        <div css={[w100, centerText]}>
                            {isError ? (
                                <h1>
                                    Błędne parametry szukania.
                                    <br /> Popraw błędy i spróbuj ponownie
                                </h1>
                            ) : (
                                <h1>
                                    Nie znaleziono ofert spełniających wybrane kryteria.
                                    <br /> Rozszerz lub zmień parametry szukania i spróbuj ponownie.
                                </h1>
                            )}
                        </div>
                    </section>
                </div>
            )}

            <OSMapForOffers
                transportRoutes={props.transportRoutes}
                viewType={ViewType.OFFER_LIST_MAP}
                onMarkerClick={props.onMarkerClick}
                offers={stateOffers}
                regionData={stateRegionData}
                favouriteOffers={favouriteOffers}
                appliedOffers={appliedOffers}
            />
        </>
    );
};

const emptyListMap = css`
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    background-image: url(${mapBg});
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 2rem;
`;
import React, {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import {css} from "@emotion/react";

import {centerText, w100} from "@pg-design/helpers-css";
import {usePrevious} from "@pg-mono/hooks";
import {RequestState} from "@pg-mono/request-state";

import {IRPStore} from "../../app/rp_reducer";
import {IOSMPoisRoutesGrouped} from "../../maps/actions/fetch_osm_pois_routes_grouped";
import {IRegionListMap} from "../../region/types/IRegionListMap";
import {ViewType} from "../../view_type/ViewType";
import {useGetMapRegionsQuery} from "../map/api/get_map_region";
import {IOfferListMapOffer} from "../types/IOfferListMapOffer";
import {OSMapForOffers} from "./os_map_for_offers/OSMapForOffers";

const mapBg = require("../map/img/map_bg.jpg");

interface IProps {
    transportRoutes: IOSMPoisRoutesGrouped[] | null;
    className?: string;
    onMarkerClick: (offerId: number) => void;
    offers: IOfferListMapOffer[];
    offersRequestState: RequestState;
    isHoliday: boolean;
    hideLayersBox?: boolean;
}

export const OfferListMap = (props: IProps) => {
    const {offers} = props;

    const selectedRegion = useSelector((state: IRPStore) => state.offerListMap.selectedRegion);
    const favouriteOffers = useSelector((state: IRPStore) => state.favourite.favourites.offers);
    const appliedOffers = useSelector((state: IRPStore) => state.offerListMap.appliedOffers.data);

    const [stateOffers, setStateOffers] = useState<IOfferListMapOffer[]>(offers);
    const {data: regionData, isSuccess: isRegionRequestSucceeded} = useGetMapRegionsQuery({region: selectedRegion.map((region) => region.id)});
    const [stateRegionData, setStateRegionData] = useState<IRegionListMap[]>(regionData?.results || []);

    const prevOffersRequestState = usePrevious(props.offersRequestState, props.offersRequestState);
    const prevRegionRequestState = usePrevious(isRegionRequestSucceeded, isRegionRequestSucceeded);

    useEffect(() => {
        const offersChanged = prevOffersRequestState !== props.offersRequestState;
        const offersSuccess = props.offersRequestState === RequestState.Success;
        const regionChanged = prevRegionRequestState !== isRegionRequestSucceeded;

        if (props.isHoliday) {
            if (offersSuccess && offersChanged) {
                setStateOffers(props.offers);
                setStateRegionData(regionData?.results || []);
            }
        } else {
            if (offersSuccess && isRegionRequestSucceeded && (offersChanged || regionChanged)) {
                setStateOffers(props.offers);
                setStateRegionData(regionData?.results || []);
            }
        }
    }, [props.isHoliday, props.offersRequestState, isRegionRequestSucceeded, props.offers, regionData, prevOffersRequestState, prevRegionRequestState]);

    const markersLength = props.offers.length;
    const isError = props.offersRequestState === RequestState.Error;

    return (
        <>
            {(!markersLength || isError) && (
                <div css={emptyListMap}>
                    <section css={centerText}>
                        <div css={[w100, centerText]}>
                            {isError ? (
                                <h1>
                                    Błędne parametry szukania.
                                    <br /> Popraw błędy i spróbuj ponownie
                                </h1>
                            ) : (
                                <h1>
                                    Nie znaleziono ofert spełniających wybrane kryteria.
                                    <br /> Rozszerz lub zmień parametry szukania i spróbuj ponownie.
                                </h1>
                            )}
                        </div>
                    </section>
                </div>
            )}

            <OSMapForOffers
                transportRoutes={props.transportRoutes}
                viewType={ViewType.OFFER_LIST_MAP}
                onMarkerClick={props.onMarkerClick}
                offers={stateOffers}
                regionData={stateRegionData}
                favouriteOffers={favouriteOffers}
                appliedOffers={appliedOffers}
            />
        </>
    );
};

const emptyListMap = css`
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    background-image: url(${mapBg});
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 2rem;
`;
